module.exports = __webpack_public_path__ + "static/media/anc3ru.d258e91a.pdf";